export function WmgLogo() {
  return (
    <img aria-label="WMG Logo" alt="WMG Logo" src="/images/wmg-logo.svg" />
  );
}

WmgLogo.displayName = 'WmgLogo';
